import { updateJWToken } from '../../../requesters/axios';
import { getClientByEmailHash, getAutocareToken } from '../../../requesters/autocare';

const LOAD_WORKSHOP_DATA = 'LOAD_WORKSHOP_DATA';
const AUTH_AUTOCARE = 'AUTH_AUTOCARE';

export function loadWorkShopData(emailHash) {
    return (dispatch) => {
        getClientByEmailHash(emailHash)
        .then((result) => {
            dispatch({
                type: LOAD_WORKSHOP_DATA,
                payload:{
                    address: result.data.address,
                    coordinates: result.data.coordinates,
                    email: result.data.email,
                    defaultAdvisorEmail: result.data.communications.defaultAdvisorEmail,
                    callmeEmail: result.data.communications.callmeEmail,
                    password: result.data.password,
                    holidays: result.data.holidays,
                    footer: result.data.footer,
                    phone: result.data.phone,
                    limitHour: result.data.limitHour
                }
            })
        })
    }

}

export function authAutocare(data, cb) {
    return (dispatch) => {
        getAutocareToken(data)
            .then((result) => {
                // Update Axios token.
                updateJWToken(result.data.token)
                dispatch({
                    type: AUTH_AUTOCARE,
                    payload: {
                        token: result.data.token
                    }
                })
            }).catch(cb)
    }
}



// WEBPACK FOOTER //
// ./src/workflow/checkout/workshop/actions.js